import '../css/form-messages.css';

const DEFAULT_ERROR = 'Something went wrong. Please try again later.';

function showFormMessages(form, type, messages) {
    const box = form.querySelector('.form-messages');
    box.innerHTML = '';
    box.classList.remove('form-messages--success', 'form-messages--error');
    box.classList.add('form-messages--' + type);

    messages.forEach(function (message) {
        const p = document.createElement('p');
        p.textContent = message;
        box.appendChild(p);
    });

    box.hidden = false;
    box.scrollIntoView({block: 'nearest'});
}

function getErrorMessages(json) {
    const messages = [];

    if (json.errors) {
        Object.keys(json.errors).forEach(function (name) {
            json.errors[name].forEach(function (message) {
                messages.push(message);
            });
        });
    }

    if (!messages.length && json.message) {
        messages.push(json.message);
    }

    if (!messages.length) {
        messages.push(DEFAULT_ERROR);
    }

    return messages;
}

function sendForm(form) {
    const button = form.querySelector('[type="submit"], button');
    if (button) {
        button.disabled = true;
        button.classList.add('loading');
    }

    form.querySelector('.form-messages').hidden = true;

    grecaptcha.ready(function () {
        grecaptcha.execute(form.dataset.recaptchaKey, {action: 'contact_form'})
            .then(function (token) {
                form.querySelector('input[name="recaptcha_token"]').value = token;

                return fetch(form.action, {
                    method: 'POST',
                    headers: {'Accept': 'application/json'},
                    body: new FormData(form)
                });
            })
            .then(function (response) {
                return response.json().then(function (json) {
                    if (response.ok) {
                        showFormMessages(form, 'success', [json.message]);
                        form.reset();
                    } else {
                        showFormMessages(form, 'error', getErrorMessages(json));
                    }
                });
            })
            .catch(function (error) {
                console.error('Form error:', error);
                showFormMessages(form, 'error', [DEFAULT_ERROR]);
            })
            .finally(function () {
                if (button) {
                    button.disabled = false;
                    button.classList.remove('loading');
                }
            });
    });
}

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.js-ajax-form').forEach(function (form) {
        form.addEventListener('submit', function (e) {
            e.preventDefault();
            sendForm(form);
        });
    });
});
